import React from 'react';
import { Trans } from '@lingui/macro';
import { RecordFlowIcon } from '@oca/icons';

import { ROOT_PATH } from './constants';
import { RecordflowMainPage } from './pages/main';

const lazyPage = (load, name) =>
  React.lazy(() => load().then(module => ({ default: module[name] })));

const DashboardPage = lazyPage(
  () => import('./pages/dashboard'),
  'DashboardPage',
);
const DocumentsPage = lazyPage(
  () => import('./pages/documents'),
  'DocumentsPage',
);
const DocumentDetailPage = lazyPage(
  () => import('./pages/document-detail'),
  'DocumentDetailPage',
);
const TransactionsPage = lazyPage(
  () => import('./pages/transactions'),
  'TransactionsPage',
);
const AppsPage = lazyPage(() => import('./pages/apps'), 'AppsPage');
const SettingsPage = lazyPage(() => import('./pages/settings'), 'SettingsPage');

export const routes = [
  {
    path: ROOT_PATH,
    component: RecordflowMainPage,
    navigation: {
      icon: <RecordFlowIcon />,
      name: <Trans>RecordFlow</Trans>,
      shortName: 'RF',
    },
    routes: [
      {
        path: `${ROOT_PATH}/dashboard`,
        component: DashboardPage,
        exact: true,
        navigation: { name: <Trans>Dashboard</Trans>, shortName: 'DB' },
      },
      {
        path: `${ROOT_PATH}/documents`,
        component: DocumentsPage,
        exact: true,
        navigation: { name: <Trans>Documents</Trans>, shortName: 'DO' },
      },
      {
        path: `${ROOT_PATH}/documents/:documentId`,
        component: DocumentDetailPage,
        exact: true,
      },
      {
        path: `${ROOT_PATH}/transactions`,
        component: TransactionsPage,
        exact: true,
        navigation: { name: <Trans>Transactions</Trans>, shortName: 'TR' },
      },
      {
        // Also serves /recordflow/apps/invoice-generator.
        path: `${ROOT_PATH}/apps`,
        component: AppsPage,
        navigation: {
          name: <Trans>Apps</Trans>,
          shortName: 'AP',
          onlyTopLevelLink: true,
        },
      },
      {
        path: `${ROOT_PATH}/settings`,
        component: SettingsPage,
        exact: true,
        navigation: { name: <Trans>Settings</Trans>, shortName: 'ST' },
      },
    ],
  },
];
